import { RecipientInformationDocument } from '@packages/gql/generated/shopping/RecipientInformationDocument';
import { useCustomer } from '@packages/shared/src/hooks/useCustomer/useCustomer';
import { useQuery } from 'urql';

/* GraphQL */ `
  query RecipientInformation($emailAddress: String!) {
    recipientInformation(recipientInformationRequest: { emailAddress: $emailAddress }) {
      hasPermission
      pending
    }
  }
`;

export const useRecipientInformationGql = () => {
  const { customer, isLoading } = useCustomer();
  const emailAddress = customer?.email || '';
  const [{ data, error }] = useQuery({
    query: RecipientInformationDocument,
    variables: { emailAddress },
    requestPolicy: 'network-only',
    pause: !customer?.email || isLoading,
  });
  if (error || !data?.recipientInformation) {
    return { hasPermission: false, pending: false };
  }
  const {
    recipientInformation: { hasPermission, pending },
  } = data;
  return { hasPermission, pending, email: customer?.email };
};
